import { provideHttpClient, withFetch } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import {
  provideClientHydration,
  withEventReplay,
  withNoHttpTransferCache,
} from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  PreloadAllModules,
  provideRouter,
  withInMemoryScrolling,
  withPreloading,
} from '@angular/router';
import { provideGoogleAnalytics } from '@core/services/google-analytics.service';
import Aura from '@primeuix/themes/aura';
import { provideLottieOptions } from 'ngx-lottie';
import { providePrimeNG } from 'primeng/config';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideGoogleAnalytics(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withPreloading(PreloadAllModules),
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled',
      })
    ),
    provideHttpClient(withFetch()),
    // No HTTP transfer cache (kept from the NgModule app): the catalog is
    // live data, so the browser refetches instead of trusting build-time HTML.
    provideClientHydration(withEventReplay(), withNoHttpTransferCache()),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: { prefix: 'p', darkModeSelector: false, cssLayer: false },
      },
    }),
    provideLottieOptions({
      player: () => import('lottie-web'),
    }),
  ],
};
